import React, { useState, useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useMsal } from '@azure/msal-react';
import classNames from 'classnames';
import {
  Avatar,
  Skeleton,
  IconButton,
  Menu,
  MenuItem,
} from '@mui/material';
import {
  Person as PersonIcon,
  Settings as SettingsIcon,
  Logout as LogoutIcon,
} from '@mui/icons-material';
import { getUserDisplayName } from 'store/user/selectors';

const menuProps = {
  transformOrigin: { horizontal: 'right', vertical: 'top' },
  anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
  classes: {
    root: 'user-settings-menu',
  },
};

const UserSettings = ({ isCollapsed }) => {
  const { instance } = useMsal();

  const [menuAnchor, setMenuAnchor] = useState(null);

  const userDisplayName = useSelector(getUserDisplayName);

  const userNameContent = useMemo(() => {
    if (!userDisplayName) {
      return (<Skeleton variant="text" />);
    } else {
      return (<span>{userDisplayName}</span>);
    }
  }, [userDisplayName]);

  const openMenu = useCallback(({ currentTarget }) => {
    setMenuAnchor(currentTarget);
  }, []);

  const onLogout = useCallback(() => {
    instance.logoutRedirect();
  }, [instance]);

  const classes = useMemo(() => {
    return classNames({
      collapsed: isCollapsed,
    }, 'user-settings-pane');
  }, [isCollapsed]);

  return (
    <div className={classes}>
      <Avatar>
        <PersonIcon />
      </Avatar>

      <div className="user-info">
        {userNameContent}
      </div>

      <IconButton onClick={openMenu}>
        <SettingsIcon />
      </IconButton>

      <Menu
        anchorEl={menuAnchor}
        open={!!menuAnchor}
        onClose={setMenuAnchor.bind(this, null)}
        {...menuProps}>
        <MenuItem onClick={onLogout}>
          <LogoutIcon fontSize="small" />
          Logout
        </MenuItem>
      </Menu>
    </div>
  );
};

export default UserSettings;
